<p-confirmDialog [baseZIndex]="10000" rejectButtonStyleClass="p-button-text"></p-confirmDialog>
<p-toast [baseZIndex]="10000" key="toast-payment-form"></p-toast>

<div class="container-fluid" [@fadeIn]="true">
  @if (isLoading) {
    <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
  } @else {
    <div class="row d-flex justify-content-center">
      <div class="col-10">
        <div class="row">
          <div class="col-1 mb-3">
            <p-button severity="secondary" icon="pi pi-undo" type="button" label="{{ 'Back' | translate }}" (click)="goBack()"></p-button>
          </div>
        </div>

        @if(!isErrorConnection){
          <p-card header="{{ 'MemoPayments.New Payment' | translate }}">
            <hr class="mt-4">
            <app-payment-form
              [isLoadingFileSequence]="isLoadingFileSequence"
              [airlineList]="airlineList"
              [countryList]="countryList"
              [minFileSequence]="minFileSequence"
              [maxFileSequence]="maxFileSequence"
              [diffValueMaxRelated]="diffValueMaxRelated"
              [isMaxRelatedHigherMax]="isMaxRelatedHigherMax"
              [isMaxRelatedZero]="isMaxRelatedZero"
              [defaultMaxRelated]="defaultMaxRelated"
              [diffCountry]="diffCountry"
              [generalError]="generalError"
              [payment]="newPaymentView"
              [isNewPayment]="true"
              [paymentSavedOk]="paymentSavedOk"
              [paymentDefaultTranslated]="paymentDefaultTranslated"
              [periodic]="periodicFrequency"
              [docTypesList]="docTypesList"
              [docTypesListSingle]="docTypesListSingle"
              [frequencyList]="frequencyList"
              [paymentTypesList]="paymentTypesList"
              [agentsMacroGroupsList]="agentsMacroGroupsList"
              [originContent]="originContent"
              [isLoadingOriginContent]="isLoadingOriginContent"
              [isLoadingMacroGroups]="isLoadingMacroGroups"
              [isLoadingRemotes]="isLoadingRemotes"
              [isLoadingCustomer]="isLoadingCustomer"
              [isSinglePayment]="isSinglePayment"
              [isPeriodicPayment]="isPeriodicPayment"
              [isPeriodRangePayment]="isPeriodRangePayment"
              [memoContentOriginSelected]="memoContentOriginSelected"
              [customerList]="customerList"
              [fileInput]="fileInput"
              [uploadRemoteList]="uploadRemoteList"
              [remoteResponseList]="remoteResponseList"
              (frequencyChoiceMethod)="frequencyChoice()"
              (modalChangeFrequencyMethod)="modalChangeFrequency()"
              (memoContentOriginChoiceMethod)="memoContentOriginChoice()"
              (customerSelectionMethod)="customerSelection($event)"
              (airlineSelectionMethod)="airlineSelection($event)"
              (countrySelectionMethod)="countrySelection($event)"
              (maxRelatedSelectionMethod)="maxRelatedSelection()"
              (paymentTypeSelectionMethod)="paymentTypeSelection()"
              (clearErrorsMethod)="clearErrors()"
              (updateMaxRelatedMethod)="updateMaxRelated()"
              (attachmentFileMethod)="attachmentFile($event)"
              (getRemotesMethod)="getRemotes()"
              (setEnableRemotesMethod)="setEnableRemotes($event)"
              [docTypeError]="docTypeError"
              [enableRemotes]="enableRemotes"
              [NameError]="NameError"
              [airlineError]="airlineError"
              [bspError]="bspError"
              [maxRelatedError]="maxRelatedError"
              [fileSequenceError]="fileSequenceError"
              [paymentError]="paymentError"
              [paymentTypeError]="paymentTypeError"
              [vatError]="vatError"
              [fromDocumentError]="fromDocumentError"
              [toDocumentError]="toDocumentError"
              [contactNameError]="contactNameError"
              [contactPhoneError]="contactPhoneError"
              [contactEmailError]="contactEmailError"
              [RMICError]="RMICError"
              [reasonForMemoError]="reasonForMemoError"
              [memoContentError]="memoContentError"
              [endTaskDateError]="endTaskDateError"
              >
            </app-payment-form>

            <div class="offset-10 col-2 mb-4 d-flex justify-content-end">
              <p-button severity="contrast" icon="pi pi-eraser" type="button" class="mr-4" label="{{ 'Common.Clear' | translate }}" (click)="resetPage()"></p-button>
              <p-button severity="primary"  icon="pi pi-save" type="button" class="mr-3" label="{{ 'Common.Save'  | translate }}" [disabled]="checkButtonSaveDisabled()" (click)="savePayment()"></p-button>
            </div>
          </p-card>
        }
      </div>
    </div>
  }
</div>
